<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_detail_of_plan'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body" style="overflow-y: auto">
                    <div style="padding:0px 10px 10px 10px">
                        <el-table :data="tableData" height="calc(100% - 111px)" style="width:100%">
                            <el-table-column prop="featureName" label="Feature" width="180"></el-table-column>
                            <el-table-column prop="talkLite" label="Talk Lite" width="180" :class-name="getColumnClassName(Const.LICENSE_PLAN_TALK_LITE)">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.talkLite" style="text-align:center"><img style="height:32px" src="../assets/icon_check_black.svg"/></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="talkEnt" label="Talk Enterprise" width="180" :class-name="getColumnClassName(Const.LICENSE_PLAN_TALK_ENT)">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.talkEnt"><img style="height:32px" src="../assets/icon_check_black.svg"/></span>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="isLiveCastLiteUser" prop="liveLite" label="Livecast Lite" width="180" :class-name="getColumnClassName(Const.LICENSE_PLAN_LIVE_LITE)">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.liveLite"><img style="height:32px" src="../assets/icon_check_black.svg"/></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="liveEnt" label="Livecast Enterprise" width="180" :class-name="getColumnClassName(Const.LICENSE_PLAN_LIVE_ENT)">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.liveEnt"><img style="height:32px" src="../assets/icon_check_black.svg"/></span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-ok-button" @click="$emit('close')">Close</el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data () {
        return {
            Const: {
                LICENSE_PLAN_TALK_LITE: constants.LICENSE_PLAN_TALK_LITE,
                LICENSE_PLAN_TALK_ENT: constants.LICENSE_PLAN_TALK_ENT,
                LICENSE_PLAN_LIVE_LITE: constants.LICENSE_PLAN_LIVE_LITE,
                LICENSE_PLAN_LIVE_ENT: constants.LICENSE_PLAN_LIVE_ENT,
            },
            tableData: [],
            featureList: [
                { id:1,   nameJp:"グループ通話",                nameEn:"Group Talk",                 TL:true,    TE:true,    LL:true,    LE:true },
                { id:2,   nameJp:"個別通話",                    nameEn:"Individual Talk",            TL:true,    TE:true,    LL:true,    LE:true },
                { id:3,   nameJp:"双方向通話",                  nameEn:"Overlapping Talk",           TL:true,    TE:true,    LL:true,    LE:true },
                { id:4,   nameJp:"マルチグループ受信",          nameEn:"Multiple Group Receive",     TL:true,    TE:true,    LL:true,    LE:true },
                { id:5,   nameJp:"電話発信",                    nameEn:"Phone call",                 TL:true,    TE:true,    LL:true,    LE:true },
                { id:6,   nameJp:"通話履歴の再生",              nameEn:"Playback of Talk",           TL:true,    TE:true,    LL:true,    LE:true },
                { id:7,   nameJp:"履歴保存期間24時間",          nameEn:"24 hours data storage",      TL:true,    TE:true,    LL:true,    LE:true },
                { id:8,   nameJp:"チャット機能",                nameEn:"Chat",                       TL:true,    TE:true,    LL:true,    LE:true },
                { id:9,   nameJp:"位置情報の確認",              nameEn:"Location Share",             TL:true,    TE:true,    LL:true,    LE:true },
                { id:10,  nameJp:"MAP通話",                     nameEn:"Map Talk",                   TL:true,    TE:true,    LL:true,    LE:true },
                { id:11,  nameJp:"企業間通信",                  nameEn:"Inter Company Communication",TL:true,    TE:true,    LL:true,    LE:true },
                { id:12,  nameJp:"強制起動",                    nameEn:"Forced Activation",          TL:true,    TE:true,    LL:true,    LE:true },
                { id:13,  nameJp:"二段階認証(メール)",          nameEn:"Two-Factor Authentication",  TL:true,    TE:true,    LL:true,    LE:true },
                { id:14,  nameJp:"かんたんログイン",            nameEn:"Easy Login",                 TL:true,    TE:true,    LL:true,    LE:true },
                { id:15,  nameJp:"ライブキャスト",              nameEn:"Livecast",                   TL:false,   TE:false,   LL:true,    LE:true },
                { id:16,  nameJp:"音声テキスト化",              nameEn:"Speech-to-Text",             TL:false,   TE:true,    LL:false,   LE:true },
                { id:17,  nameJp:"トランシーバー翻訳",          nameEn:"Transceiver Translation ",   TL:false,   TE:true,    LL:false,   LE:true },
                { id:18,  nameJp:"動態管理",                    nameEn:"Location Tracking",          TL:false,   TE:true,    LL:false,   LE:true },
                { id:19,  nameJp:"アプリ設定の一括管理",        nameEn:"Global App Settings",        TL:false,   TE:true,    LL:false,   LE:true },
                { id:20,  nameJp:"エンドツーエンド暗号化",      nameEn:"End-to-end Encryption",      TL:false,   TE:true,    LL:false,   LE:true },
                { id:21,  nameJp:"管理コンソールIPアドレス制限",nameEn:"IP Address Restrictions",    TL:false,   TE:true,    LL:false,   LE:true },
                { id:22,  nameJp:"管理コンソール監査ログ",      nameEn:"Audit Trail",                TL:false,   TE:true,    LL:false,   LE:true },
                { id:23,  nameJp:"SAML認証",                    nameEn:"SAML Authentication",        TL:false,   TE:true,    LL:false,   LE:true },
                { id:24,  nameJp:"履歴保存一か月延長",          nameEn:"1 month data storage",       TL:false,   TE:true,    LL:false,   LE:true },
                { id:25,  nameJp:"外部ストレージ連携",          nameEn:"External Storage",           TL:false,   TE:true,    LL:false,   LE:true },
                { id:26,  nameJp:"アプリ連携",                  nameEn:"App collaboration",          TL:false,   TE:true,    LL:false,   LE:true },
                { id:27,  nameJp:"端末管理",                   nameEn:"Device Management",          TL:false,   TE:true,    LL:false,   LE:true },
            ]
        };
    },
    methods: {
        getFunctionName(functionInfo) {
            if (this.$i18n.locale == "ja") {
                return functionInfo.nameJp;
            } else {
                return functionInfo.nameEn;
            }
        },
        getColumnClassName(selectedPlanType) {
            if (this.selectedPlanType == selectedPlanType) {
                return "feature-selected";
            } else {
                return "feature-non-selected";
            }
        },
    },
    created: function() {
        for (let feature of this.featureList) {
            this.tableData.push({ featureName: this.getFunctionName(feature), talkLite: feature.TL, talkEnt: feature.TE, liveLite: feature.LL, liveEnt: feature.LE });
        }
    },
    mounted: function() {
    },
    computed: {
        isLiveCastLiteUser() {
            return this.purchasePlanType === this.Const.LICENSE_PLAN_LIVE_LITE;
        }
    },
    watch: {
    },
    components: {
    },
    props: [ 'selectedPlanType', 'purchasePlanType' ]
}
</script>

<style>
th.feature-selected {
    padding-top: 10px;
    text-align: center !important;
    background-color: #f6f6f6;
}
.feature-selected {
    padding-top: 10px;
    text-align: center !important;
    background-color: #f6f6f6;
}
.feature-non-selected {
    padding: 10px;
    text-align: center !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.item-record {
    border-top: 1px #eee solid;
    border-bottom: 1px #eee solid;
}
.description-table {
    width:100%;
    text-align:center;
}
</style>
